<template>
  <el-card>
    <div slot="header" class="font-weight-bold d-flex justify-content-between">
      <div>{{ $tc('general.delivery_address', 2) }}</div>
      <el-link type="primary" @click="onAddAddress">
        {{ $t('general.add') }}
      </el-link>
    </div>
    <div>
      <div
        v-for="address in deliveryAddresses"
        :key="address.id"
        class="text-left border-bottom mb-2 pb-1 d-flex justify-content-between"
      >
        <div class="d-flex flex-column">
          <span class="font-weight-bold">{{ address.get('contactPerson') }}</span>
          <span class="small">
            {{ address.get('country') }} {{ address.get('zipCode') }} {{ address.get('city') }},
            {{ address.get('street') }}
          </span>
        </div>
        <div>
          <el-button type="danger" circle @click="onDeleteAddress(address)">
            <i class="el-icon-delete" />
          </el-button>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import StoreModules from '../../../store/store-modules';
import AddDeliveryAddressModal from '../../../components/modals/AddDeliveryAddressModal';
export default {
  name: 'ManageDeliveryAddressCard',
  components: {},
  props: {},
  mounted() {
    this.loadAddresses();
  },
  destroyed() {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(StoreModules.DELIVERY_ADDRESSES, ['deliveryAddresses', 'isLoading']),
  },
  methods: {
    ...mapActions(StoreModules.DELIVERY_ADDRESSES, ['loadAddresses']),
    onAddAddress() {
      this.$modal.show(AddDeliveryAddressModal, {}, { height: 'auto', width: '90%' });
    },
    async onDeleteAddress(address) {
      address.set('deleted', true);
      await address.save();
      await this.loadAddresses(true);
      this.$message.info(this.$t('messages.success_config_update'));
    },
  },
};
</script>

<style scoped></style>
